import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { ItemType } from 'dibs-recent-history/exports/types';

import {
    SharedCarouselWrapper,
    ClassNames,
    ItemClick,
    ItemImpression,
} from '../SharedCarouselWrapper/SharedCarouselWrapper';

import { SharedRecentlyFavoritedItems_viewer$key } from './__generated__/SharedRecentlyFavoritedItems_viewer.graphql';

type Props = {
    isClient: boolean;
    classNames?: ClassNames;
    showFullHeader?: boolean;
    itemsPerPage?: number;
    viewer: SharedRecentlyFavoritedItems_viewer$key;
    onViewMoreCtaClick?: (actionLabel: string) => void;
    onItemClick?: ({ item, index, actionLabel }: ItemClick) => void;
    onItemImpression?: ({ items, index, actionLabel }: ItemImpression) => void;
};

const VIEW_MORE_URL = '/favorites/favorited/';
const TITLE = 'Recently Saved';
const TITLE_ID = 'shared.recentlySaved';
const CAROUSEL_TYPE = 'saved';
const ACTION_LABEL = 'recently saved';

export const SharedRecentlyFavoritedItems: FC<Props> = ({
    isClient,
    classNames,
    showFullHeader,
    itemsPerPage,
    viewer: viewerRef,
    onViewMoreCtaClick,
    onItemClick,
    onItemImpression,
}) => {
    const viewer = useFragment(
        graphql`
            fragment SharedRecentlyFavoritedItems_viewer on Viewer {
                portfolios(first: 1, portfolioTypes: HEART, userIds: [$userId])
                    @include(if: $fetchUser) {
                    edges {
                        node {
                            items(first: 12) {
                                edges {
                                    node {
                                        item {
                                            title
                                            serviceId
                                            browseUrl
                                            firstPhotoWebPath(size: large)
                                            categoryCode
                                            contemporaryTrackingString
                                            categoryPath
                                            localizedPdpUrl
                                            seller {
                                                serviceId
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
        viewerRef
    );

    const edges = viewer.portfolios?.edges;
    const items: ItemType[] =
        (edges &&
            edges[0]?.node?.items?.edges?.map(egde => {
                const item = egde?.node?.item;
                return {
                    category: item?.categoryPath || '',
                    contemporaryTrackingString: item?.contemporaryTrackingString || '',
                    dealerPk: item?.seller?.serviceId || '',
                    itemBrowseUrl: item?.browseUrl || '',
                    itemCategoryCode: item?.categoryCode || '',
                    itemId: item?.serviceId || '',
                    itemImageUrl: item?.firstPhotoWebPath || '',
                    itemPdpUrl: item?.localizedPdpUrl || '',
                    itemTitle: item?.title || '',
                };
            })) ||
        [];

    return (
        <SharedCarouselWrapper
            isClient={isClient}
            classNames={classNames}
            showFullHeader={showFullHeader}
            itemsPerPage={itemsPerPage}
            items={items}
            onViewMoreCtaClick={onViewMoreCtaClick}
            onItemClick={onItemClick}
            onItemImpression={onItemImpression}
            viewMoreHref={VIEW_MORE_URL}
            title={TITLE}
            titleId={TITLE_ID}
            carouselType={CAROUSEL_TYPE}
            actionLabel={ACTION_LABEL}
        />
    );
};
